import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { ConfigElement } from "./ConfigElement";
import { ModalHeaderComponent } from "./ModalHeaderComponent";
import { SaveButtonComponent } from "./SaveButtonComponent";

type PropsType = {
    setIsOpen: (value: boolean) => void;
    isOpen: boolean;
    setIsConfigurationModalOpened: Function;
    setIsLoading: Function;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
};

export function DefaultSettingModal({
    setIsOpen,
    isOpen,
    setIsConfigurationModalOpened,
    setIsLoading,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: PropsType): JSX.Element {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                isOpen={isOpen}
            >
                <ModalHeaderComponent setIsOpen={setIsOpen} isOpen={isOpen} />
                <ModalBody className="ml-2">
                    <ConfigElement />
                </ModalBody>
                <ModalFooter>
                    <CustomSecondaryColorButton
                        className="w-20 kds_btn_validateTemplate"
                        rounded
                        variant="primary"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {t("Annuler")}
                    </CustomSecondaryColorButton>
                    <SaveButtonComponent
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                        setIsConfigurationModalOpened={
                            setIsConfigurationModalOpened
                        }
                        setIsLoading={setIsLoading}
                        setIsModalLoadingOpened={setIsModalLoadingOpened}
                        setModalLoadingData={setModalLoadingData}
                    />
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
